import custFollowWithReport from './custFollowWithReport'
export default custFollowWithReport
